import { ServicesHistoryervice } from './../../../versions/services/serviceHistoryService';
import { Videos } from './../../models/videos';
import { NbDialogRef, NbToastrService } from '@nebular/theme';
import { Component, OnInit } from '@angular/core';
import { VideosService } from '../../services/videosService';
import { Router } from '@angular/router';

@Component({
  selector: 'ngx-add-vedio',
  templateUrl: './add-vedio.component.html',
  styleUrls: ['./add-vedio.component.css'],
})
export class AddVedioComponent implements OnInit {
  serviceId: number;
  videos: Videos;
  serviceHistoryId: number;
  constructor(
    private diagRef: NbDialogRef<AddVedioComponent>,
    private service: VideosService,
    private toast: NbToastrService,
    private history: ServicesHistoryervice,
    private route : Router
  ) {
    this.videos = {} as Videos;
  }

  ngOnInit(): void {
      this.route.events.subscribe(()=>{
      this.diagRef.close('false');
     });
  }

  add() {
    this.videos.serviceId = this.serviceId;
    this.service.post(this.videos).subscribe(
      (res) => {
        this.toast.show('تم إضافة الفيديو بنجاح', '', { status: 'success', duration: 3000 });
        this.diagRef.close('true');
      },
      (error) => {
        this.toast.show('خطأ في حفظ الفيديو ', '', { status: 'danger', duration: 3000 });
      },
    );
  }
}
